module.exports = __webpack_public_path__ + "img/zko3.c580fcd1.jpg";